'use strict';

const ol = require('openlayers');

/**
 * @name MapOptions
 * @type {Object}
 * @property {string} type
 * @property {EventEmitter} mapEvents
 * @property gmap_selector
 * @property gmap_options_default
 * @property gmap_options
 * @property placeType
 * @property outer_frame_selectors
 * @property container_selector
 * @property outer_frame_selectors
 * @property icon_default
 * @property facility_type_name_table
 * @property place_image_path
 */

class OpenLayerLatLng {
  /**
   * @param {ol.Coordinate}
   */
  constructor(coord) {
    this.coord = coord;
  }
  
  lat() {
    return this.coord[1];
  }
  
  lng() {
    return this.coord[0];
  }
  
  toCoordinate() {
    return this.coord;
  }
}

/**
 * OpenLayerで表示する
 * 
 * @name OpenLayerMap
 * @extends {Map}
 */
export default class OpenLayerMap{
  
  /**
   * @param {EventEmitter} mapEvents
   * @param {PopupFactory} popupFactory
   * @param {PlaceType} placeType
   * @param {MapOptions} options
   */
  constructor(mapEvents, popupFactory, placeType, options) {
    this.mapEvents = mapEvents;
    this.popupFactory = popupFactory;
    this.placeType = placeType;
    this.options = options;
    this.olmarkers = {};
    // TODO: OpenLayers版マーカーマージンは未実装
    this.markerMargin = {
      set: false,
      weight: this.options.marginWeight,
      map: {},
      index: {}
    };
    // 静的マーカー用レイヤー
    this.staticMarkerLayerSource = new ol.source.Vector({});
    this.staticMarkerLayer = new ol.layer.Vector({
      source: this.staticMarkerLayerSource
    });
  
    this.interval = 0;
    this.timerID = [];
    this.displayingPlaces = null;
    this.forceMarkerOpen = false;
  }
  
  /**
   * 初期化
   *
   * @access public
   */
  reset() {
  }
  
  /**
   * ih.start()で呼ばれる
   *
   * @access public
   */
  start() {
    this.olmap = this.createMap();
    this.setMapController();
    this.registerMarkerEvent();
    this.registerChangeZoomEvent();
  }
  
  createMap() {
    
    let mapSource = null;
    
    // マップ画像の読込み元の設定（オンラインOSM）
    if (this.options.olmap_options.useOnlineOSM) {
      
      mapSource = new ol.source.OSM();
      
    // マップ画像の読込み元の設定（ローカルタイリングマップ画像）
    } else if (this.options.olmap_options.tilingMapPath) {
      mapSource = new ol.source.XYZ({
        url: this.options.olmap_options.tilingMapPath
      });
    }
    
    // マップを描画するラスタレイヤの設定
    let mapLayer = new ol.layer.Tile({
      source: mapSource
    });
    
    // 動的マーカ用のベクタレイヤの設定
    let dynamicMarkerLayerSource = new ol.source.Vector({});
    let dynamicMarkerLayer = new ol.layer.Vector({
      source: dynamicMarkerLayerSource
    });
  
    // マーカポップアップ用のDOMの設定
    $('#gmap').append('<div id="popup"></div>');
    
    // マーカポップアップ用のオーバーレイの設定
    let infowindowLayer = new ol.Overlay({
      element: document.getElementById('popup'),
      positioning: 'center-center',
      stopEvent: true // ポップアップをクリックした時に、下に隠れたマーカが反応しないようにする
    });
    
    // 各メソッドからレイヤを操作するため、レイヤをクラスプロパティとして保持
    this.dynamicMarkerLayerSource = dynamicMarkerLayerSource;
    this.dynamicMarkerLayer = dynamicMarkerLayer;
    this.infowindowLayer = infowindowLayer;
    
    // マップのビューの定義
    let view = new ol.View({
      projection: "EPSG:3857",
      rotation: this.options.olmap_options.rotation,
      zoom: this.options.olmap_options.zoom,
      maxZoom: this.options.olmap_options.maxZoom,
      minZoom: this.options.olmap_options.minZoom
    });
    
    // マップの定義・描画
    return new ol.Map({
      target: this.options.olmap_options.selector,
      layers: [mapLayer, this.staticMarkerLayer, dynamicMarkerLayer],
      overlays: [infowindowLayer],
      view: view,
      controls: ol.control.defaults({
        attributionOptions: ({
          collapsible: false
        })
      })
    });
    
  }
  
  setMapController(){
    // 縮尺を表示
    if (this.options.olmap_options.control.scaleLine) {
      this.olmap.addControl(new ol.control.ScaleLine());
    }
    // 拡大・縮小スライダーを表示
    if (this.options.olmap_options.control.zoomSlider) {
      this.olmap.addControl(new ol.control.ZoomSlider());
      $('.ol-zoomslider').css({
        'border': '1px solid darkgray'
      });
    }
    
    // ピンチ操作などで指定ズーム範囲を越えると(解像度の変化で判定)、指定ズーム範囲に抑える（動物園マップ専用なので一旦コメントアウト）
    // let view = this.olmap.getView();
    // view.on('change:resolution', (e) => {
    //   if(parseFloat(e.oldValue) > 1.2){
    //     view.setZoom(this.options.gmap_options_default.minZoom);
    //   }
    //   if(parseFloat(e.oldValue) < 0.297){
    //     view.setZoom(this.options.gmap_options_default.maxZoom);
    //   }
    // });
  }
  
  registerChangeZoomEvent () {
    const view = this.olmap.getView();
    view.on('change:resolution', event => {
      this.mapEvents.emit('ihChangeZoom', view.getZoom());
    });
  }
  
  /**
   * 動的マーカ上のイベントを設定する
   * ・マーカマウスオーバー: カーソルを指型に変更
   * ・マーカクリック: マーカポップアップを生成
   * ・ポップアップ閉じるボタンクリック: ポップアップを閉じる
   */
  registerMarkerEvent() {
    // マーカ上でマウスカーソルを指型に変更
    let target = this.olmap.getTarget();
    let jTarget = typeof target === "string" ? $("#" + target) : $(target);
    $( this.olmap.getViewport() ).on('mousemove', (evt) => {
      let pixel = that.olmap.getEventPixel(evt.originalEvent);
      let hit = this.olmap.forEachFeatureAtPixel(pixel, function (feature, layer) {
        return !feature.getProperties().static;
      });
      if (hit) {
        jTarget.css("cursor", "pointer");
      } else {
        jTarget.css("cursor", "");
      }
    });
  
    // マーカー選択時にポップアップを生成する
    this.olmap.on('click',(event) => {
      let marker = this.olmap.forEachFeatureAtPixel(event.pixel, (clickedMarker) => {
        return clickedMarker;
      });
      if (marker) {
        let properties = marker.getProperties();
        if ( properties.id === null || properties.static ) {
          return;
        }
        this.mapEvents.emit('ihClickMarker', properties.place, marker, properties.popup);
      }
    });
    
    // ポップアップを閉じるボタンの配置・デザイン
    let popupCloser = $('<a href="#" id="popup-closer">×</a>');
    $('#popup').append(popupCloser);
    popupCloser.css({
      'font-size': '20px',
      'text-decoration': 'none',
      'position': 'absolute',
      'top': '0px',
      'right': '8px'
    });
    
    // ポップアップを閉じる処理
    let that = this;
    popupCloser.on('click', function () {
      that.closeMarkerPopup();
      $(this).blur();
      return false;
    });
  }
  
  /**
   * マーカーを地図上にプロットする
   *
   * @access public
   * @param {Request} request
   * @param {Array} places
   */
  displayMarkers(request, places) {
    this.displayingPlaces = places;
    let len = places.length;
    for (let i = 0; i < len; i++) {
      let place = places[i];
      if (!place) {
        continue;
      }
      this.timerID[i] = setTimeout(() => {
        let marker = this.createMarker(place);
        let popup = this.createMarkerPopup(place, marker);
        marker.setProperties({popup: popup});
        $(this).trigger('ihDisplayedOneMarker', [places, place, marker, popup]);
        if (i === places.length - 1 ) {
          $(this).trigger('ihDisplayedAllMarkers', [places, marker, popup]);
        }
      }, i * this.interval);
    }
  }
  
  /**
   * 施設オブジェクト(Place)を基に、マーカを生成し、olmarkersで管理する
   *
   * @access protected
   * @param {Place} place
   * @returns {ol.Feature}
   */
  createMarker(place) {
    
    if (!place) {
      return;
    }
    
    if (!this.olmarkers['places']) {
      this.olmarkers['places'] = {};
    }
    if (!this.olmarkers['static']) {
      this.olmarkers['static'] = {};
    }
    
    // 対象のマーカが生成済みならそのまま返す？
    if (this.olmarkers['places'][place.id]){
      return this.olmarkers['places'][place.id];
    }
    
    // マーカー生成
    let marker = this._createMarkerObject(place);
  
    if ('static' in place && place.static) {
      this.olmarkers['static'][place.id] = marker;
    }
    if (!('static' in place)) {
      this.olmarkers['places'][place.id] = marker;
    }
    
    return marker;
    
  }
  
  /**
   * マーカ(ol.Feature)を生成する
   * オーバーライド許可するが、markerを内部管理する必要があるのでcreateMarker以外からは呼ばないように
   *
   * @access private
   * @param {Place} place
   * @returns {ol.Feature}
   */
  _createMarkerObject(place){
    // デフォルトマーカー画像（施設IDベースで自動割り当て）
    let markerIcon = new ol.style.Icon({
      anchor: [0.5, 40],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: this.placeType.getMarkerIcon(place.type)
    });
    // デフォルトラベル（青細字）
    let markerLabel = new ol.style.Text({
      fill: new ol.style.Fill({color: "navy"}),
      stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
      scale: 1.4,
      textAlign: "center",
      offsetY: 0,
      text: place.name
    });
    
    // 施設オブジェクトがアイコン非表示設定の場合はラベルのみ表示する（黒太字）
    if ('showIcon' in place && !place.showIcon) {
      markerIcon = new ol.style.Icon({
        anchor: [0.5, 0.5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: 'img/nothing.png'
      });
      markerLabel.setFill(new ol.style.Fill({color: 'black'}));
      markerLabel.setScale(1.6);
    } else if ( !('showIcon' in place) || place.showIcon ) {
      // 施設オブジェクトにマーカー用画像の指定がある場合はその画像をマーカーに用いる
      if ('icon_pin' in place) {
        markerIcon = new ol.style.Icon({
          anchor: [0.5, 40],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: place.icon_pin,
        });
      }
    }
    // 2行目用ラベル
    if ('newline' in place && place.newline) {
      markerLabel.setOffsetY(17);
    }
    
    // マーカの内容設定（座標, id, 名称, 種別）
    let feature = new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.transform([place.lng, place.lat], "EPSG:4326", "EPSG:3857")),
      id: place.id,
      name: place.name,
      type: place.type,
      lat: place.lat,
      lng: place.lng,
      place: place,
      static: place.static
    });
    
    // マーカーアイコン・ラベル設定
    const markerStyle = new ol.style.Style({
      image: markerIcon
    });
    if (this.options.useDefaultMarkerLabel || ('static' in place && place.static) ) {
      markerStyle.setText(markerLabel);
    }
    feature.setStyle(markerStyle);
  
    if ('static' in place && place.static) {
      this.staticMarkerLayerSource.addFeature(feature);
    } else {
      this.dynamicMarkerLayerSource.addFeature(feature);
    }
    
    return feature;
  }
  
  /**
   *
   * @param {ol.Feature} marker
   * @param {Object} labelStyle
   */
  setMarkerLabel (marker, labelStyle = null) {
    if (labelStyle) {
      const style = marker.getStyle();
      const textStyle = new ol.style.Text({
        font: labelStyle.fontFamily,
        fill: new ol.style.Fill({color: 'navy'}), //labelStyle.color
        stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
        scale: 1.4,
        textAlign: "center",
        offsetY: 0,
        text: labelStyle.text
      });
      style.setText(textStyle);
      marker.setStyle(style);
    }
  }
  
  /**
   * マーカーのポップアップを生成し、イベントリスナーに登録する
   *
   * @access protected
   * @param {Place} place
   * @param {ol.Feature} marker
   * @return {DOMElement}
   */
  createMarkerPopup(place, marker){
    
    // 施設オブジェクトが与えられなかった場合、マーカオブジェクトから取得
    if (!place){
      place = marker.get('place');
    }
    
    // ポップアップのDOMを生成
    let popup = this.popupFactory.build(place);
    
    // ポップアップDOMにdata-id(遺跡ID)を設定
    $(popup).data('id', place.id);
    
    return popup;
  }
  
  /**
   * マーカーポップアップを開く
   *
   * @access public
   * @param marker
   * @param popup
   */
  toggleMarkerPopup(marker, popup){
    if (!this.forceMarkerOpen && this.isOpenMarkerPopup(popup)){
      this.closeMarkerPopup();
    }else{
      this.setMarkerPopup(marker, popup);
      this.forceMarkerOpen = false;
    }
  }
  
  /**
   * 指定のマーカーポップアップが開いているか？
   *
   * @param popup
   * @returns {boolean}
   */
  isOpenMarkerPopup(popup){
    const currentPlaceId = $('.info-window').data('place-id');
    const newPlaceId = $(popup).data('place-id');
    return currentPlaceId === newPlaceId;
  }
  
  /**
   * マーカポップアップを表示する
   *
   * @param marker
   * @param popup
   */
  setMarkerPopup(marker, popup){
    this.infowindowLayer.setPosition(ol.proj.transform([marker.get('lng'), marker.get('lat')], "EPSG:4326", "EPSG:3857"));
    $('.info-window').remove();
    $('#popup').append(popup);
  }
  
  /**
   * マーカーポップアップを閉じる
   *
   */
  closeMarkerPopup(){
    $('.info-window').remove();
    this.infowindowLayer.setPosition(undefined);
  }
  
  /**
   * マーカーを全消去
   *
   * @access public
   */
  clearMarkersAll() {
    
    if(this.dynamicMarkerLayer){
      this.dynamicMarkerLayer.getSource().clear();
      this.closeMarkerPopup();
    }
    
    this.olmarkers.places = {};
    
  }
  
  clearStaticMarkersAll () {
    if(this.staticMarkerLayer){
      this.staticMarkerLayer.getSource().clear();
    }
    this.olmarkers.static = {};
  }
  
  /**
   * マップ中心位置、基準位置を変更する
   * 
   * @access public
   * @param {OpenLayerLatLng} latlng
   */
  setCenterAndCurrentLocation(latlng) {
    
    // OpenLayerLatLngをol.Coordinateに変換して中心位置をセット
    this.olmap.getView().setCenter(latlng.toCoordinate());
    
    // 現在の基準位置を更新
    this.updateCurrentLocation(latlng);
  
    // this.olmap.on('moveend', this.displayCenterMarker);
    
  }
  
  /**
   * 検索の基準位置を変更する
   *
   * @access public
   * @param {OpenLayerLatLng} latlng
   * @returns {OpenLayerLatLng}
   */
  updateCurrentLocation(latlng) {
    
    if (!latlng) {
      var c = this.olmap.getView().getCenter();
      latlng = this.createLatLng(c[0], c[1]);
    }
    
    // 基準位置マーカを表示する
    // this.displayBaseMarker(latlng);
  
    this.current_search_location = latlng;
    return this.current_search_location;
    
  }
  
  /**
   * 検索時の基準位置を取得する
   *
   * @access public
   * @returns {OpenLayerLatLng}
   */
  getCurrentSearchLocation(){
    return this.current_search_location;
  }
  
  /**
   * 基準位置マーカーを表示
   *
   * @param {OpenLayerLatLng} latlng
   */
  displayBaseMarker(latlng) {
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(latlng.toCoordinate()),
      id: null,
      name: '近つ飛鳥博物館'
    });
    
    // マーカのスタイル設定（画像, 文字）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/pin/base_pin.png',
      }),
      text: new ol.style.Text({
        fill: new ol.style.Fill({color: "red"}),
        stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
        scale: 1.4,
        textAlign: "center",
        offsetY: 0,
        text: '近つ飛鳥博物館'
      })
    }));
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  displayCurrentLocationMarker(latlng){
    
    // 現在地マーカが表示済みの場合、一旦削除
    if(this.layerM){
      this.clearCurrentLocationMarker();
    }
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(latlng.toCoordinate()),
      id: null,
      name: '現在地'
    });
  
    // マーカのスタイル設定（画像, 文字）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/pin/base_pin.png',
      }),
      text: new ol.style.Text({
        fill: new ol.style.Fill({color: "red"}),
        stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
        scale: 1.4,
        textAlign: "center",
        offsetY: 0,
        text: '現在地'
      })
    }));
  
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
  
    this.layerM = layer;
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  existCurrentLocationMarker(){
    if(!this.layerM){
      return false;
    } else {
      if(this.layerM.getSource().getFeatures().length == 0){
        return false;
      } else {
        return true;
      }
      
    }
  }
  
  clearCurrentLocationMarker(){
    this.layerM.getSource().clear();
  }
  
  /**
   * 中心位置マーカーを表示
   *
   *
   */
  displayCenterMarker(evt) {
    
    var map = evt.map;
    
    if(this.layerCM){
      this.layerCM.getSource().clear();
    }
    
    // マーカの内容設定
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(map.getView().getCenter()),
      id: null
    });
    
    // マーカのスタイル設定（画像）
    feature.setStyle(new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 40],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        src: '../sites/tennoji-zoo/assets/img/center_marker.png',
        scale: 0.8
      })
    }));
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature]
      })
    });
    
    // ベクタレイヤをマップに追加
    map.addLayer(layer);
    
    this.layerCM = layer;
    
  }
  
  /**
   * 施設名のみ（マーカなし）をFeature形式で表示
   *
   *
   */
  displayFacilityName (facilities) {
    var features = [];
    
    for(var i = 0; i < facilities.length; i++){
      
      // マーカの内容設定（座標, id, 名称, 種別）
      features[i] = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([facilities[i].lng, facilities[i].lat], "EPSG:4326", "EPSG:3857")),
        id: facilities[i].id,
        name: facilities[i].name,
        lat: facilities[i].lat,
        lng: facilities[i].lng,
        facilities: facilities
      });
  
      // マーカのスタイル(画像, 文字)をズームレベルによって動的設定
      features[i].setStyle(new ol.style.Style({
        text: new ol.style.Text({
          fill: new ol.style.Fill({color: "red"}),
          stroke: new ol.style.Stroke({color: "#ffffff", width: 2}),
          scale: 1.0,
          textAlign: "center",
          offsetY: 0,
          text: facilities[i].name
        })
      }));
  
    }
    
    // マーカを表示するベクタレイヤの設定
    var layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: features
      })
    });
    
    // ベクタレイヤをマップに追加
    this.olmap.addLayer(layer);
    
  }
  
  /**
   * 検索範囲を指定した場合に用いる、円を表示
   *
   * @access public
   * @param r
   */
  displayCircle(r) {
  }
  
  /**
   * 現在表示中のマーカーを取得
   *
   * @access public
   * @returns {Array.<ol.Feature>}
   */
  getDisplayMarkers(){
    return this.olmarkers['places'];
  }
  
  /**
   * 施設マーカーを取得
   *
   * @access public
   * @param id
   * @returns {google.maps.Marker}
   */
  getPlaceMarker(id){
    
  }
  
  /**
   * 表示予定の施設オブジェクトを取得
   *
   * @returns {Array|*|null}
   */
  getDisplayingPlaces () {
    return this.displayingPlaces;
  }
  
  getTimerID () {
    return this.timerID;
  }
  
  displayFacilityMarkers(places){
    
    // マーカ表示済みの場合、一旦全て削除する
    if(this.layerF){
      this.layerF.getSource().clear();
      $('.info-window').remove();
      this.overlay.setPosition(undefined);
    }
    
    // ズーム・中心座標を初期値に戻す
    this.fitBounds(places);
  
    var markers = [];
  
    for (var i = 0, len = places.length; i < len; i++) {
    
      var place = places[i];
      if (!place) continue;
    
      // マーカーを生成
      markers[i] = this.createMarker(place);
    }
  
    // マーカをベクタレイヤに追加
    this.vectorSourceF.addFeatures(markers);
  
    // マーカ上でマウスカーソルを変更
    var that = this;
    var target = this.olmap.getTarget();
    var jTarget = typeof target === "string" ? $("#" + target) : $(target);
    $(this.olmap.getViewport()).on('mousemove', function (evt) {
      var pixel = that.olmap.getEventPixel(evt.originalEvent);
      var hit = that.olmap.forEachFeatureAtPixel(pixel, function (feature, layer) {
        return true;
      });
      if (hit) {
        jTarget.css("cursor", "pointer");
      } else {
        jTarget.css("cursor", "");
      }
    });
      
  }
  
  
  
  /**
   * 
   * @param lat
   * @param lng
   * @returns {OpenLayerLatLng}
   */
  createLatLng(lat, lng) {
    return new OpenLayerLatLng( ol.proj.fromLonLat( [parseFloat(lng), parseFloat(lat)] ) );
  }

  /**
   * 中心位置オブジェクトを取得
   *
   * @access public
   * @returns {OpenLayerLatLng}
   */
  getCenter() {
    return new OpenLayerLatLng(this.olmap.getView().getCenter())
  }
  
  /**
   *
   * @access public
   * @params {OpenLayerLatLng} latlng
   */
  setCenter(latlng) {
    // OpenLayerLatLngをol.Coordinateに変換して中心位置をセット
    this.olmap.getView().setCenter(latlng.toCoordinate());
  }
  
  /**
   *
   * @access public
   * @params {number} zoom
   */
  setZoom(zoom){
    this.olmap.getView().setZoom(zoom);
  }
  
  /**
   * 指定された座標に地図を移動させる
   *
   * @access public
   * @param {number} lat
   * @param {number} lng
   * @param {boolean?} circle
   * @return {boolean} 戻り値
   */
  moveMap(lat, lng, circle) {
  }
  /**
   * 指定施設に移動して、マーカークリック動作を起動
   * 
   * @access public
   * @param place
   */
  moveAndFocus(place){
  }
  /**
   * マーカーがクリックされた際の処理
   * 
   * @access public
   */
  focusMarker(place) {
    // focusMarker(markerNum) {
    
    /*
     * TODO: ol.Mapの、特定のfeatureの'click'イベントをtriggerする方法がわからない
     * 替わりに、EventEmitterで'ihClickMarker'を発生させている
     * そのためには、placeオブジェクトと、popupオブジェクトが必要なので、
     * focusMarker()のパラメータをmarkerNum(= place.id)からplaceオブジェクトに変更している
     * z.core.displaySearchResultRowのfocusMarker()のパラメータも合わせて変更している
     */
    
    if(place){
      var p = this.popupFactory.build(place);
      $(p).data('id', place.id);
      var m = this.olmarkers['places'][place.id];
      this.mapEvents.emit('ihClickMarker', place, m, p);
    }
    
  }
  /**
   * 仕方なく外からgooglemapを操作したい時
   * 
   * @access public
   * @returns {google.maps.Map}
   */
  getMap() {
  }
  /**
   * 指定の施設が全て表示されるようにズームと位置調整する
   *
   * @param {Array} places
   * @param {Boolean} enable
   */
  fitBounds(places, enable = true) {
    if (enable && places.length !== 0) {
      const lats = places.map( place => {
        return place.lat;
      });
      const lngs = places.map( place => {
        return place.lng;
      });
      const maxLat = lats.reduce( (a, b) => {
        return Math.max(a, b);
      });
      const maxLng = lngs.reduce( (a, b) => {
        return Math.max(a, b);
      });
      const minLat = lats.reduce( (a, b) => {
        return Math.min(a, b);
      });
      const minLng = lngs.reduce( (a, b) => {
        return Math.min(a, b);
      });
      const max = this.createLatLng(maxLat, maxLng);
      const min = this.createLatLng(minLat, minLng);
      this.olmap.getView().fit([min.lng(), min.lat(), max.lng(), max.lat()], this.olmap.getSize());
    }
  }
  
  /**
   * 静的画像レイヤーを作成する
   *
   * @param {String} url
   * @param {Object} bounds {north(maxLat = maxY), south(minLat = minY), east(maxLon = maxX), west(minLon = minX)}
   * @param {Number} opacity
   * @returns {ol.layer.Image}
   */
  createStaticImageLayer (url, bounds, opacity = 1) {
    const max = this.createLatLng(bounds.north, bounds.east);
    const min = this.createLatLng(bounds.south, bounds.west);
    return new ol.layer.Image({
      source: new ol.source.ImageStatic({
        imageExtent: [min.lng(), min.lat(), max.lng(), max.lat()],
        projection: "EPSG:3857",
        url: url
      }),
      opacity: opacity
    });
  }
  
  /**
   * レイヤーを挿入する
   * 挿入位置は動的・静的マーカーレイヤーとベースマップレイヤーの間に順次挿入
   *
   * @param layer
   */
  addLayer (layer) {
    const layers = this.olmap.getLayers();
    const index = layers.getLength() - 2;
    this.olmap.getLayers().insertAt(index, layer);
  }
  
  removeLayer (layer) {
    this.olmap.removeLayer(layer);
  }
  
  /**
   *
   * @returns {Array} [N, S, E, W]
   */
  getBounds () {
    const extent = this.olmap.getView().calculateExtent(this.olmap.getSize());
    const min = ol.proj.toLonLat([extent[0], extent[1]]);
    const max = ol.proj.toLonLat([extent[2], extent[3]])
    return [max[1], min[1], max[0], min[0]];
  }
  getNorthEnd () {
    return this.getBounds()[0];
  }
  getSouthEnd () {
    return this.getBounds()[1];
  }
  getEastEnd () {
    return this.getBounds()[2];
  }
  getWestEnd () {
    return this.getBounds()[3];
  }
  
  getZoom () {
    return this.olmap.getView().getZoom();
  }
  
  setMaxZoom (maxZoom) {
    this.olmap.setView(new ol.View({
      center: this.getCenter().toCoordinate(),
      projection: "EPSG:3857",
      rotation: this.options.olmap_options.rotation,
      zoom: this.options.olmap_options.zoom,
      maxZoom: maxZoom,
      minZoom: this.options.olmap_options.minZoom
    }));
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/map/OpenLayerMap.js